<template>
  <v-container class="grey lighten-5" fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Szczegóły subskrypcji
          </v-card-title>
          <v-card-text>
            <SubscriptionAddEdit
                :id="this.id"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SubscriptionAddEdit from "@/components/subscriptions/SubscriptionAddEdit";

export default {
  components: {
    SubscriptionAddEdit,
  },
  props: {
    id: {
      type: [String],
      required: true,
    }
  },
}
</script>